"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useSnapshotToSimpleDataSource(snapshot) {
    return (0, react_1.useMemo)(function () {
        var _a;
        return (_a = snapshot === null || snapshot === void 0 ? void 0 : snapshot.docs.map(function (s) {
            return __assign(__assign({}, s.data()), { id: s.id });
        })) !== null && _a !== void 0 ? _a : [];
    }, [snapshot]);
}
exports.default = useSnapshotToSimpleDataSource;
